(function() {
  document.addEventListener('DOMContentLoaded', function () {
    (function() {
      const cards = document.querySelectorAll('.product-block');
      const breakpoint = window.matchMedia('(min-width: 990px)');

      if (!cards.length) {
        return;
      }

      let flag = false;

      const onMouseoverHandle = function (card, video) {
        card.classList.add('is-visible');
        if (video) {
          video.play();
        }
      };

      const onMouseleaveHandle = function (card, video) {
        card.classList.remove('is-visible');
        if (video) {
          video.pause();
        }
      };

      const breakpointChecker = () => {
        cards.forEach(function (card) {

          const video = card.querySelector('video');
          const contentMedia = card.querySelector('.product-block__image');
          
          if (breakpoint.matches) {  
                    
            contentMedia.addEventListener('mouseover', function(evt) {
              onMouseoverHandle(card, video);
            });
        
            contentMedia.addEventListener('mouseleave', function() {
              onMouseleaveHandle(card, video);          
            });

          }
        });
      };

      breakpoint.addListener(breakpointChecker);
      breakpointChecker(); 
    })();

  });

})();